module.exports = __webpack_public_path__ + "static/media/hanwah.aa39ac0a.jpg";